import React, { PureComponent } from 'react';
import { Icon, Row, Col } from 'antd';
import { LinkType } from '../../design_page/components/tools';
import { LinkTypeMode } from '../../design_page/types';
import { mitt } from '../../services';
// 热区编辑
export class HotZoneItem extends PureComponent<{
    items?: Array<any>;
    index?: number;
    onChange?: (value: any) => void;
    item?: any;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    effectiveTime?: { start: string; end: string };
    selector: any;
    activeIndex: string;
}> {
    change = (item: any) => {
        const { index, onChange } = this.props;
        mitt.emit('hot-zone-item-change', { item, index, onChange });
    };

    removeItem = () => {
        const { index, onChange } = this.props;
        mitt.emit('hot-zone-item-remove', { index, onChange });
    };

    render() {
        const { item, linkTypes, linkTypeMode, activeIndex, index, selector } = this.props;

        return (
            <Row
                className="entry-item"
                style={{
                    border: activeIndex && +activeIndex === index ? '1px solid blue' : '',
                }}
            >
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />

                <Col className="entry-item-content" span={19}>
                    <LinkType
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        selector={selector}
                        onChange={this.change}
                    />
                </Col>
            </Row>
        );
    }
}
